import { action, computed, makeObservable, observable } from "mobx";
import ModalStore, { ModalStoreProps } from "./modal.store";
import UserDetailsWrapper from "self-service/users/management/user-details-wrapper";

export type PermissionThatCanBeGiven = {
    isEnabled: boolean,
    permission: number,
    name: string,
    isChecked: boolean
}

class UserModalStore extends ModalStore {
    user?: UserDetailsWrapper;
    isUpdate = false;
    pageNumber = 1;
    permissions: PermissionThatCanBeGiven[] = [];

    constructor(initialValues?: ModalStoreProps) {
        super(initialValues);

        makeObservable(this, {
            user: observable,
            isUpdate: observable,
            pageNumber: observable,
            permissions: observable,
            reset: action,
            updateIsUpdate: action,
            updateUser: action,
            updatePageNumber: action,
            updatePermissions: action,
            updatePermission: action,
            updateAllPermissions: action,
            selectedPermissions: computed,
            areAllPermissionsSelected: computed
        });
    }

    reset() {
        this.display = false;
        this.user = undefined;
        this.isUpdate = false;
        this.pageNumber = 1;
    }

    updateIsUpdate(value: boolean) {
        this.isUpdate = value;
    }

    updateUser(value: UserDetailsWrapper) {
        this.user = value;
    }

    updatePageNumber(value: number) {
        this.pageNumber = value;
    }

    updatePermission(permssion: number, isChecked: boolean) {
        const match = this.permissions.find(x => x.permission === permssion);

        if (!match) {
            return;
        }

        match.isChecked = isChecked;
    }

    updatePermissions(value: PermissionThatCanBeGiven[]) {
        this.permissions = value;

        // console.log("Checked Items", this.selectedPermissions);
    }

    updateAllPermissions(isChecked: boolean) {
        this.permissions.forEach(x => x.isChecked = x.isEnabled && isChecked);
    }

    get selectedPermissions() {
        return this.permissions.filter(x => x.isChecked).map(x => x.permission);
    }

    get areAllPermissionsSelected() {
        const enabled = this.permissions.filter(x => x.isEnabled);

        return enabled.every(x => x.isChecked);
    }
}

export default UserModalStore;
